import { render, staticRenderFns } from "./ModalExportarProcedimentos.vue?vue&type=template&id=210473be&scoped=true"
import script from "./ModalExportarProcedimentos.vue?vue&type=script&lang=js"
export * from "./ModalExportarProcedimentos.vue?vue&type=script&lang=js"
import style0 from "./ModalExportarProcedimentos.vue?vue&type=style&index=0&id=210473be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210473be",
  null
  
)

export default component.exports